import React, { useState, useEffect } from "react";
import { ImageSelector } from "./ImageSelector.jsx";
import { MdDelete } from "react-icons/md";
import { IoMdAdd } from "react-icons/io";
import { MessagePopup } from "components/shared/Popups.jsx";

const HDI_Form = ({ location, onSubmit, title, formName }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState([]);
  const [popup, setPopup] = useState({ show: false, message: "", type: "" });


  useEffect(() => {
    console.log("🔄 Fetching latest form data from location...");
    if (Array.isArray(location[formName])) {
      setFormData(
        location[formName].map((data) => ({
          title: data.title || "",
          desc: data.desc || "",
          selectedImage: data.selectedImage || null,
          ...(formName === "trekProducts" && { productLink: data.productLink || "" }),
          ...(formName === "imageGallery" && { session: data.session || "Summer" }),
        }))
      );
    }
  }, [location, formName]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setPopup({ show: true, message: "Submitting...", type: "loading" });

    try {
      const updatedData = { ...location, [formName]: formData };
      const response = await onSubmit(updatedData);

      if (response) {
        setFormData(response[formName] || []);
        setPopup({ show: true, message: "✅ Form submitted successfully!", type: "success" });
      }
    } catch (error) {
      console.error("❌ Error saving form:", error);
      setPopup({ show: true, message: "❌ Failed to submit the form. Please try again.", type: "error" });
    } finally {
      setLoading(false);
      setTimeout(() => setPopup({ show: false, message: "", type: "" }), 3000);
    }
  };


  const handleChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [name]: value } : item))
    );
  };

  const handleImageSelection = (selectedImage, selectedIndex) => {
    setFormData((prev) =>
      prev.map((item, i) =>
        i === selectedIndex ? { ...item, selectedImage } : item
      )
    );
  };

  const handleAddMore = () => {
    setFormData((prev) => [
      ...prev,
      {
        title: "",
        desc: "",
        selectedImage: null,
        ...(formName === "trekProducts" && { productLink: "" }),
        ...(formName === "imageGallery" && { session: "Summer" }),
      },
    ]);
  };

  const handleRemove = (index) => setFormData((prev) => prev.filter((_, i) => i !== index));

  return (
    <form style={styles.formContainer} onSubmit={submit}>
      {popup.show && (
        <MessagePopup
          message={popup.message}
          type={popup.type}
          onClose={() => setPopup({ show: false, message: "", type: "" })}
        />
      )}
      <h3 style={styles.title}>{title}</h3>
      {formData.map((item, index) => (
        <div key={index} style={styles.gridContainer}>
          <div className="inputWrapper">
            <label>Title</label>
            <input
              type="text"
              name="title"
              value={item.title}
              onChange={(e) => handleChange(index, e)}
              required
            />
          </div>
          <div className="inputWrapper">
            <label>Description</label>
            <input
              type="text"
              name="desc"
              value={item.desc}
              onChange={(e) => handleChange(index, e)}
            />
          </div>
          {formName === "trekProducts" && (
            <div className="inputWrapper">
              <label>Product Link</label>
              <input
                type="text"
                name="productLink"
                value={item.productLink}
                onChange={(e) => handleChange(index, e)}
                required
              />
            </div>
          )}
          <div className="inputWrapper">
            <ImageSelector
              selectedImage={item.selectedImage}
              handleImageSelection={(image) => handleImageSelection(image, index)}
            />
          </div>
          {formName === "imageGallery" && (
            <div className="inputWrapper">
              <label>Select Session</label>
              <div>
                <label style={{ margin: "5px" }}>
                  <input
                    type="radio"
                    name={`session-${index}`}
                    value="Summer"
                    checked={item.session === "Summer"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: { name: "session", value: e.target.value },
                      })
                    }
                  />
                  Summer
                </label>
                <label style={{ margin: "5px" }}>
                  <input
                    type="radio"
                    name={`session-${index}`}
                    value="Monsoon"
                    checked={item.session === "Monsoon"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: { name: "session", value: e.target.value },
                      })
                    }
                  />
                  Monsoon
                </label>
                <label style={{ margin: "5px" }}>
                  <input
                    type="radio"
                    name={`session-${index}`}
                    value="Winter"
                    checked={item.session === "Winter"}
                    onChange={(e) =>
                      handleChange(index, {
                        target: { name: "session", value: e.target.value },
                      })
                    }
                  />
                  Winter
                </label>
              </div>
            </div>
          )}
          <button
            type="button"
            onClick={() => handleRemove(index)}
            style={styles.deleteButton}
          >
            <MdDelete />
          </button>
        </div>
      ))}
      <hr style={styles.divider} />
      <div style={styles.footer}>
        <button
          type="button"
          onClick={handleAddMore}
          style={styles.addButton}
        >
          <IoMdAdd /> Add More
        </button>
        <button
          type="submit"
          disabled={loading}
          style={styles.submitButton}
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </form>
  );
};

const styles = {
  formContainer: {
    padding: "20px",
    maxWidth: "100%",
    margin: "auto",
    background: "#f8f9fa",
    borderRadius: "10px",
    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  },
  title: {
    textAlign: "left",
    marginBottom: "20px",
    color: "#333",
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    alignItems: "center",
    marginBottom: "15px",
    background: "#fff",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
  },
  deleteButton: {
    background: "#dc3545",
    color: "white",
    border: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    cursor: "pointer",
    width: "fit-content",
  },
  addButton: {
    padding: "10px 15px",
    background: "#007bff",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  submitButton: {
    padding: "10px 15px",
    background: "#28a745",
    color: "white",
    border: "none",
    borderRadius: "5px",
    cursor: "pointer",
  },
  divider: {
    marginBottom: "30px",
    border: "0.5px solid #ddd",
  },
  footer: {
    display: "flex",
    justifyContent: "start",
    gap: "10px",
  },
  session: {
    margin: '15px'
  }
};

export const MajorAttractions = (props) => (
  <HDI_Form {...props} formName="majorAttractions" title="Major Attractions" />
);
export const ImageGallery = (props) => (
  <HDI_Form {...props} formName="imageGallery" title="Image Gallery" />
);
export const TrekProducts = (props) => (
  <HDI_Form {...props} formName="trekProducts" title="Trek Products" />
);
export const BestPlaces = (props => (
  <HDI_Form {...props} formName='bestPlaces' title='Best Places' />
))
export const MustExperince = (props => (
  <HDI_Form {...props} formName='MustExperince' title='Must Experince' />
))
export const Festival = (props => (
  <HDI_Form {...props} formName='Festival' title='Festival' />
))
export const MustBuy = (props => (
  <HDI_Form {...props} formName='MustBuy' title='Must Buy' />
))
export const StapleFood = (props => (
  <HDI_Form {...props} formName='StapleFood' title='Staple Food' />
))
export const FamousFood = (props => (
  <HDI_Form {...props} formName='FamousFood' title='Famous Food' />
))